import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import apiConfig from "../utils/apiConfig";
import { DefaultResponseWithData } from "../models/system";
import { IAmazonMvl } from "../models/mvl/IAmazonMvl";

export default function useMvlSearch(
  // Betty clamps anything over 200 back down to 50, so 200 is the usable ceiling.
  params: { make?: string; model?: string; query?: string; take?: number },
  enabled: boolean = true,
  componentName = "useMvlSearch"
) {
  const { get } = useApiHelper(apiConfig(componentName));

  const search = useQuery({
    queryKey: ["mvl", "search", params.make, params.model, params.query, params.take],
    queryFn: () => {
      const qs = new URLSearchParams();
      if (params.make) qs.set("make", params.make);
      if (params.model) qs.set("model", params.model);
      if (params.query) qs.set("query", params.query);
      if (params.take) qs.set("take", String(params.take));
      const queryString = qs.toString();
      return get<DefaultResponseWithData<IAmazonMvl[]>>(
        `/mvl/search${queryString ? `?${queryString}` : ""}`
      );
    },
    enabled: enabled && !!(params.make || params.model || params.query),
    staleTime: 1000 * 60,
  });

  return {
    search,
    results: search.data?.data ?? [],
  };
}
